export default __webpack_public_path__ + "static/media/sign-up-img-4.3d91ec8a.png";